<script>
const Moment = require('moment');
import { firebase } from '@firebase/app'
import '@firebase/firestore'
const { Timestamp } = firebase.firestore

export default {
  timestampParser(object, schemas) {
    // for (let i in schemas) {
    //   if (!object[i]) {
    //     continue
    //   }
    if (schemas.type === 'object') {
      for (let i in schemas.properties) {
        if (!object[i]) {
          continue
        }
        object[i] = this.timestampParser(object[i], schemas.properties[i])
      }
    }
    else if(schemas.type === 'array') {
      for (let j in object) {
        object[j] = this.timestampParser(object[j], schemas.items)
      }
    }
    else {
      // for (let i in schemas.properties) {
        object = Timestamp.fromDate(Moment.utc(object, Moment.ISO_8601, true).toDate())
      // }
    }
    // }
    return object
  },
}
</script>